<template>
  <div>
    <el-tooltip :content="taskStatusLabel" placement="top">
      <i
        v-if="taskStatus === TASK_STATUS.CHO_PHE_DUYET_DK"
        class="fas fa-clock color__blue icon-status icon-CHOPHEDUYET"
      ></i>
      <i
        v-else-if="taskStatus === TASK_STATUS.DANG_THUC_HIEN"
        class="fas fa-play-circle color__yellow icon-status icon-DANGTRIENKHAI"
      ></i>
      <i
        v-else-if="taskStatus === TASK_STATUS.HUY_PHE_DUYET_DK"
        class="fas fa-pause-circle color__silver icon-status icon-HUYPHEDUYET"
      ></i>
      <i
        v-else-if="taskStatus === TASK_STATUS.HOAN_THANH"
        class="fas fa-check-circle color__green icon-status icon-HOANTHANH"
      ></i>
      <i
        v-else-if="taskStatus === TASK_STATUS.TAM_DUNG"
        class="fas fa-pause-circle color__yellow icon-status icon-HUY"
      ></i>
      <i
        v-else-if="taskStatus === TASK_STATUS.KET_THUC"
        class="fas fa-check-double color__green icon-status icon-KETTHUC"
      ></i>
      <i
        v-else-if="taskStatus === TASK_STATUS.HUY"
        class="fas fa-times-circle color__red icon-status icon-HUY"
      ></i>
    </el-tooltip>
  </div>
</template>
<script>
  import constants from "../../../constants";
  import errorMessageFilter from "../../../filters/errorMessageFilter";

  export default {
    name: "task-status-icon",
    props: ["taskStatus"],
    data() {
      return {
        TASK_STATUS: constants.TASK_STATUS,
        taskStatusLabel: null
      };
    },

    created() {
      this.initTaskStatusLabel();
    },

    methods: {
      initTaskStatusLabel() {
        switch (this.taskStatus) {
          case constants.TASK_STATUS.CHO_PHE_DUYET_DK:
            this.taskStatusLabel = errorMessageFilter({
              errorCode: "task.status.chopheduyetdk.label"
            });
            break;
          case constants.TASK_STATUS.DANG_THUC_HIEN:
            this.taskStatusLabel = errorMessageFilter({
              errorCode: "task.status.dangthuchien.label"
            });
            break;
          case constants.TASK_STATUS.HUY_PHE_DUYET_DK:
            this.taskStatusLabel = errorMessageFilter({
              errorCode: "task.status.huypheduyetdangky.label"
            });
            break;
          case constants.TASK_STATUS.HOAN_THANH:
            this.taskStatusLabel = errorMessageFilter({
              errorCode: "task.status.hoanthanh.label"
            });
            break;
          case constants.TASK_STATUS.TAM_DUNG:
            this.taskStatusLabel = errorMessageFilter({
              errorCode: "task.status.tamdung.label"
            });
            break;
          case constants.TASK_STATUS.KET_THUC:
            this.taskStatusLabel = errorMessageFilter({
              errorCode: "task.status.ketthuc.label"
            });
            break;
          case constants.TASK_STATUS.HUY:
            this.taskStatusLabel = errorMessageFilter({
              errorCode: "task.status.huy.label"
            });
            break;
        }
      }
    }
  };
</script>

<style scoped>
  .icon-status {
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/job/components/TaskStatusIcon.vue